import { render } from "./Configurazione.vue?vue&type=template&id=1e28acc0"
import script from "./Configurazione.vue?vue&type=script&lang=js"
export * from "./Configurazione.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__